export default __webpack_public_path__ + "static/media/user-journey-img3.e987ed4e.svg";